class LifestyleController {

    constructor() {
        this.model = plannerApplication.studyPlannerProfile.getLifestyle();
        this.view = new LifestyleView(
            this.onSelectionChanged.bind(this),
            this.onMinutesSelectionChanged.bind(this),
            this.onDaySelectionChanged.bind(this),
        );

        let thisObj = this;
        let activityNo = 0;
        this.model.getActivities().each(function(activity){
            let view = thisObj.view.activityViews[activityNo];
            view.update(activity.isSelected(), activity.getDuration(), activity.getDays());
            activityNo += 1;
        })
    }

    onSelectionChanged(activityNo, isSelected) {
        this.model.getActivities().at(activityNo).setSelected(isSelected);
        plannerApplication.userDataUpdated();
    }

    onMinutesSelectionChanged(activityNo, minutes) {
        this.model.getActivities().at(activityNo).setDuration(minutes);
        plannerApplication.userDataUpdated();
    }

    onDaySelectionChanged(activityNo, days) {
        this.model.getActivities().at(activityNo).setDays(days);
        plannerApplication.userDataUpdated();
    }
}
